import React from 'react';
import { useSelector } from 'react-redux';
import { ReduxSelector } from 'store/types';
import {
  makeSelectResourceLoadingState,
  makeSelectResourceResponse,
} from './api.selectors';
import { RequestLoadingState } from './api.types';

export const useSelectApiResourceLoadState = (resourceId: string) => {
  const selectLoadingState = React.useMemo<ReduxSelector<RequestLoadingState>>(
    () => makeSelectResourceLoadingState(resourceId),
    [resourceId],
  );

  return useSelector(selectLoadingState);
};

export const useSelectApiResourceResponse = <TData, TError>(
  resourceId: string,
) => {
  return useSelector(makeSelectResourceResponse<TData, TError>(resourceId));
};
